<template>
  <div class="intro-page-ar">
    <div class="content">
      <h1>Before you<br>start...</h1>
      <p>Download the marker<br>and print it out</p>
      <p>Place it where you want your<br>Hope-Sculpture to appear!</p>

      <a @click="onDownloadClick" href="/static/img/marker.png" target="_blank">
        <el-button class="download-btn">Download</el-button>
      </a>
    </div>
  </div>
</template>

<script>
import ElButton from 'element-ui/packages/button'

export default {
  name: 'IntroPageAR',

  components: {
    ElButton
  },

  methods: {
    onDownloadClick () {
      this.$emit('download:click')
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';
@import 'mixins';

.intro-page-ar {
  width: 100%;
  height: 100%;

  position: fixed;
  top: 0;
  left: 0;

  background-color: rgba(0, 0,0 ,0.7);
  z-index: 1;

  text-align: center;
}

h1,
p {
  color: $c-white;
}

h1 {
  font-size: 32px;
  text-transform: uppercase;

  margin-bottom: 30px;
  line-height: 40px;
  letter-spacing: 2px;
}

p {
  font-size: 18px;
  line-height: 22px;
}

.download-btn {
  margin-top: 70px;

  height: 40px;
  border-radius: 7px;
  background: rgba(230, 226, 226, 0.25);
  color: $c-white;
  line-height: 19px;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1px;
}

.content {
  position: absolute;

  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);

  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/atoms/IntroPageAR.vue